export default __webpack_public_path__ + "static/gpt3-f5abd1feff8d9d8b3d25439d71502fca.png";